module.exports = new __parcel__URL__("silver_pack.30fa1902.png").toString();